var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center"},[_c('SIcon',{staticClass:"mr-1",attrs:{"size":"default","color":"iconNeutral","icon":_setup.icon}}),_c(_setup.SEllipsisTooltip,{staticClass:"textPrimary--text",attrs:{"content":_setup.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }